import alt from 'alt'
import { createStore, datasource, bind } from 'alt-utils/lib/decorators'
import { SEOSettingsActions } from 'actions'

@createStore(alt)
export default class SEOSettingsStore {
  constructor() {
    this.state = {
      fetching: null,
      settings: null,
      errored: false,
      saved: true
    }

    this.bindActions(SEOSettingsActions)
  }

  static displayName = 'SEOSettingsStore'

  setFetching(fetching) {
    this.setState({ fetching })
  }

  setSettings(settings) {
    this.setState({ settings: settings, fetching: false, saved: true })
  }

  updateSettings(settings) {
    this.setState({ settings: {
      ...this.state.settings,
      ...settings,
    }, fetching: false, saved: true })
  }

  setErrored(errored) {
    this.setState({ errored, fetching: false })
  }
}


// WEBPACK FOOTER //
// ./app/stores/SEOSettingsStore.js